import { SAFE_ZONE_INSET, SHAPE_HALF } from '../constants'
import type { ImageContent } from '../types'

export interface ImageBox {
  x: number
  y: number
  w: number
  h: number
  centerX: number
  centerY: number
}

export function computeImageBox(
  image: HTMLImageElement,
  content: ImageContent,
  centerX: number,
  centerY: number,
  scale: number = 1,
): ImageBox {
  const baseSize = (SHAPE_HALF - SAFE_ZONE_INSET) * 2 * scale
  const natural = Math.max(image.width, image.height)
  const scaleFactor = (baseSize / natural) * content.scale
  const width = image.width * scaleFactor
  const height = image.height * scaleFactor
  const x = centerX - width / 2 + content.x * scale
  const y = centerY - height / 2 + content.y * scale

  return {
    x,
    y,
    w: width,
    h: height,
    centerX: x + width / 2,
    centerY: y + height / 2,
  }
}

const dataUrlCache = new WeakMap<HTMLImageElement, string>()

export function imageToDataUrl(image: HTMLImageElement): string {
  const cached = dataUrlCache.get(image)

  if (cached) {
    return cached
  }

  const canvas = document.createElement('canvas')

  canvas.width = image.naturalWidth || image.width
  canvas.height = image.naturalHeight || image.height

  const context = canvas.getContext('2d')
  let url: string

  if (context) {
    context.drawImage(image, 0, 0)
    try {
      url = canvas.toDataURL('image/png')
    } catch {
      url = image.src
    }
  } else {
    url = image.src
  }

  dataUrlCache.set(image, url)

  return url
}
